import React from 'react';

const Trophy = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
        <g fill="none" fillRule="evenodd">
            <path fill="none" d="M-30-311h420v685H-30z" />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M24.7 2.6h-3.9V1.3A1.3 1.3 0 0 0 19.5 0h-13a1.3 1.3 0 0 0-1.3 1.3v1.3H1.3A1.3 1.3 0 0 0 0 3.9v3.9A5.2 5.2 0 0 0 5.2 13h2.002a7.8 7.8 0 0 0 4.498 2.483V18.2h-1.3a3.9 3.9 0 0 0-3.9 3.9v2.6A1.3 1.3 0 0 0 7.8 26h10.4a1.3 1.3 0 0 0 1.3-1.3v-2.6a3.9 3.9 0 0 0-3.9-3.9h-1.3v-2.717A7.8 7.8 0 0 0 18.798 13H20.8A5.2 5.2 0 0 0 26 7.8V3.9a1.3 1.3 0 0 0-1.3-1.3ZM5.2 10.4a2.6 2.6 0 0 1-2.6-2.6V5.2h2.6v2.6a7.8 7.8 0 0 0 .455 2.6H5.2Zm10.4 10.4a1.3 1.3 0 0 1 1.3 1.3v1.3H9.1v-1.3a1.3 1.3 0 0 1 1.3-1.3h5.2Zm2.6-13a5.2 5.2 0 1 1-10.4 0V2.6h10.4v5.2Zm5.2 0a2.6 2.6 0 0 1-2.6 2.6h-.455a7.8 7.8 0 0 0 .455-2.6V5.2h2.6v2.6Z"
            />
        </g>
    </svg>
);

export default Trophy;
